import React, { useState, useEffect } from "react";
import ChatContainer from "../../PatientApp/containers/Chat/ChatContainer";
// import ReversedChatTestContainer from "../../PatientApp/containers/Chat/ReversedChatTestContainer";
import history from "../../history";

const AgentChat = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { document.title = "Chat — myPatientSpace"; }, []);

  return (
    <main id="main-layout" className="agent-chat">
      <ChatContainer patient={"68594f0844db7f759a027416"} />
    </main>
  );
};

export default AgentChat;
